// import { faMagnifyingGlass } from "@fortawesome/pro-light-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import React from "react";

const SearchIcon = ({ color = "#007bff", onClick }) => {
  return (
    <div style={{ position: "absolute", right: 4, top: 4 }}>
      <span>search icon component</span>
      {/* <FontAwesomeIcon
        icon={faMagnifyingGlass}
        style={{
          cursor: "default",
          color,
        }}
        onClick ={onClick}
      /> */}
    </div>
  );
};

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/components/SearchIcon.js